'use client';

import Icon from '@/components/ui/AppIcon';

export default function FeaturesSection() {
  const features = [
    {
      icon: 'BoltIcon',
      title: 'Instant Delivery',
      description: 'Receive your verifiable flight ticket within minutes via email'
    },
    {
      icon: 'ShieldCheckIcon',
      title: 'Embassy Verified',
      description: 'Valid PNR accepted by embassies and consulates worldwide'
    },
    {
      icon: 'GlobeAltIcon',
      title: 'Airline Verified',
      description: 'Real booking in airline systems with active PNR code'
    },
    {
      icon: 'CreditCardIcon',
      title: 'Secure Payment',
      description: 'Safe and encrypted payment processing with money-back guarantee'
    },
    {
      icon: 'ClockIcon',
      title: '24/7 Support',
      description: 'Round-the-clock customer support for all your queries'
    },
    {
      icon: 'DocumentCheckIcon',
      title: 'No Risk',
      description: 'Full refund if your visa application is rejected'
    }
  ];

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-black text-gray-900 mb-2">Why Choose Our Service?</h2>
        <p className="text-gray-600">Trusted by thousands of travelers worldwide</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-start gap-4 p-4 rounded-lg hover:bg-blue-50 transition-colors">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <Icon name={feature?.icon} size={24} className="text-blue-600" />
              </div>
            </div>
            <div>
              <h3 className="font-bold text-gray-900 mb-1">{feature?.title}</h3>
              <p className="text-sm text-gray-600">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}